import React, { useEffect, useRef, useState } from 'react';
import OneFamVideo from '../../videos/one-fam-trailer.mp4';
import { StaticImage } from 'gatsby-plugin-image';
import './index.scss';

export const sections = [
  { title: 'about', id: 'about' },
  { title: 'services', id: 'services' },
  { title: 'team', id: 'team' },
  { title: 'location', id: 'location' },
];

export interface HeaderProps {
  handleNavigateLink: (id: string) => void;
}

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(function Header(
  { handleNavigateLink },
  ref
) {
  const [displayStaticHeader, setDisplayStaticHeader] =
    useState<boolean>(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [isAlertActive, setIsAlertActive] = useState<boolean>(true);

  useEffect(() => {
    const main = document.querySelector('main');
    if (main) {
      main.addEventListener('scroll', () => {
        if (window.innerWidth > 720) {
          setDisplayStaticHeader(main.scrollTop > 179);
        } else {
          setDisplayStaticHeader(main.scrollTop > 200);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (isDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [isDrawerOpen]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleAlert = () => {
    setIsAlertActive(isAlertActive);
  };

  return (
    <>
      <nav
        ref={ref}
        id='navigation-header'
        className={displayStaticHeader ? 'active' : ''}
      >
        <header>
          <div onClick={() => handleNavigateLink('landing')}>
            <StaticImage
              objectFit='contain'
              className='logo'
              height={40}
              layout='fixed'
              src='../../images/one-fam-logo-black.svg'
              alt='ONEFAM Logo'
              placeholder='none'
            />
          </div>
        </header>
        <ul>
          {sections.map((section) => (
            <li
              key={`nav-link-${section.id}`}
              id={`nav-link-${section.id}`}
              onClick={() => handleNavigateLink(section.id)}
            >
              {section.title}
            </li>
          ))}
        </ul>
        {/* {isAlertActive && (
          <div className={'book-now-alert '}>
            <a href='https://getsquire.com/booking/book/onefam-glendale-heights'>
              book your next appointment
            </a>
          </div>
        )} */}
      </nav>
      <div
        className={
          displayStaticHeader
            ? isDrawerOpen
              ? 'menu-icon active'
              : 'menu-icon static'
            : isDrawerOpen
            ? 'menu-icon active'
            : 'menu-icon'
        }
      >
        <input
          id='menu-button'
          className='menu-icon__checkbox'
          type='checkbox'
          checked={isDrawerOpen}
          onChange={toggleDrawer}
        />
        <div>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id='navigation-drawer' className={isDrawerOpen ? 'active' : ''}>
        <ul>
          {sections.map((section) => (
            <li
              key={`drawer-link-${section.id}`}
              id={`drawer-link-${section.id}`}
              onClick={() => {
                setIsDrawerOpen(false);
                handleNavigateLink(section.id);
              }}
            >
              {section.title}
            </li>
          ))}
          <li
            key={`drawer-link-book`}
            id={`drawer-link-book`}
            onClick={() => {
              setIsDrawerOpen(false);
              location.href = 'https://getsquire.com/booking/brands/onefam';
            }}
          >
            book your
            <br />
            appointment
          </li>
        </ul>
      </div>
    </>
  );
});

export default Header;
